// extracted by mini-css-extract-plugin
export var dropdown = "_tn-0";
export var imageWrapper = "_tn-3";
export var itemNameContainer = "_tn-1";
export var productImage = "_tn-2";
export var spinnerWrapper = "_tn-4";